import React from 'react';
import PropTypes from 'prop-types';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import CloseIcon from '@mui/icons-material/MenuOpen';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ListAltIcon from '@mui/icons-material/ListAlt';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import { NAV_DRAWER_WIDTH } from '../../configs/Constants';
import RoutePaths from '../../configs/Routes';
import NavItem from './NavItem';

const SideBar = ({ open, onClose }) => (
  <Drawer
    open={open}
    variant="persistent"
    anchor="left"
    onClose={onClose}
    sx={{
      width: NAV_DRAWER_WIDTH,
      flexShrink: 0,
      '& .MuiDrawer-paper': {
        minWidth: NAV_DRAWER_WIDTH,
        bgcolor: 'background.paper',
      },
    }}
  >
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        height: 80,
        flexShrink: 0,
        px: 0.5,
        position: 'sticky',
        top: 0,
        zIndex: 'appBar',
        backgroundColor: 'inherit',
        backgroundImage: 'inherit',
      }}
    >
      <IconButton aria-label="Close navigation drawer" onClick={onClose} size="large">
        <CloseIcon />
      </IconButton>
    </Stack>

    <nav>
      <List disablePadding>
        <li>
          <NavItem to={RoutePaths.REPORTS}>
            <ListItemIcon>
              <AssessmentOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Reports" />
          </NavItem>
        </li>
        <li>
          <NavItem to={RoutePaths.ORDERS}>
            <ListItemIcon>
              <ListAltIcon />
            </ListItemIcon>
            <ListItemText primary="Orders" />
          </NavItem>
        </li>
        <li>
          <NavItem to={RoutePaths.PARTIES}>
            <ListItemIcon>
              <PeopleOutlineIcon />
            </ListItemIcon>
            <ListItemText primary="Parties" />
          </NavItem>
        </li>
        <li>
          <NavItem to={RoutePaths.COLLECTIONS}>
            <ListItemIcon>
              <BusinessCenterOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Collections" />
          </NavItem>
        </li>
        <li>
          <NavItem to={RoutePaths.LEDGER}>
            <ListItemIcon>
              <MenuBookOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Ledger" />
          </NavItem>
          <li>
            <NavItem to={RoutePaths.SYNC_LOGS}>
              <ListItemIcon>
                <CloudSyncIcon />
              </ListItemIcon>
              <ListItemText primary="Sync Logs" />
            </NavItem>
          </li>
        </li>
        <li>
          <NavItem to={RoutePaths.PRODUCTS}>
            <ListItemIcon>
              <Inventory2OutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Products" />
          </NavItem>
        </li>
        <li>
          <NavItem to={RoutePaths.SETTINGS}>
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </NavItem>
        </li>
        <Divider variant="middle" sx={{ my: 1 }} />
        <li>
          <NavItem to={RoutePaths.LOGOUT}>
            <ListItemIcon>
              <ExitToAppOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </NavItem>
        </li>
      </List>
    </nav>
  </Drawer>
);

SideBar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SideBar;
